import React from 'react';
import { FaEnvelope, FaClock } from 'react-icons/fa';
import ApplicationStatus from '../cards/ApplicationStatus';
import '../../css/common/JewishLearningCard.css';

const JewishLearningCard = ({ fellowship, onClick }) => {


  return (
    <div className="jewish-learning-card-component" onClick={onClick}>
      <div className="jewish-learning-card-content">
        <h3 className="jewish-learning-card-name">{fellowship.name}</h3>
        <div className="jewish-learning-card-duration">
          <FaClock className="jewish-learning-card-duration-icon" />
          <span>{fellowship.duration}</span>
        </div>
        <div className="jewish-learning-card-contact">
          <FaEnvelope className="jewish-learning-card-email-icon" title={`Contact ${fellowship.contact.name}`} />
        </div>
        <div className="jewish-learning-card-status">
          <ApplicationStatus status={fellowship.applicationStatus} />
        </div>
      </div>
    </div>
  );
};

export default JewishLearningCard; 